import { useState, useEffect } from "react";

export const useUpdateCard = (open, data) => {
    const [isValid, setIsValid] = useState(true)
    const [form, setForm] = useState({});
    const [error, setErrors] = useState("");
    const [loader, setLoader] = useState(true);

    const onHandleChange = (e) => {
        let f = form;
        let er = error;

        f["reimbursement_deadline"] = e.target.value;
        if (!e.target.value) {
            er = "Dato obligatorio";
        } else {
            er = "";
        }

        setForm(JSON.parse(JSON.stringify(f)));
        setErrors(JSON.parse(JSON.stringify(er)));
        validate(f, er);
    };

    const validate = (f, er) => {
        f.reimbursement_deadline && !er ? setIsValid(false) : setIsValid(true);
    };

    useEffect(() => {
        if (open) {
            let newForm = {
                uuid: data['uuid'] || data.row.uuid,
                updated_by: data.agent,
            }
            if(data['row'] && data['row']['reimbursement_deadline']){
                newForm['reimbursement_deadline'] = data.row.reimbursement_deadline
            } else {
                setIsValid(false)
            }
            setForm(newForm)
            setLoader(false)
        } else {
            setLoader(true)
            setForm({})
            setIsValid(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return { onHandleChange, form, error, isValid, loader };
};
